import React from 'react';
import { Field } from 'react-final-form';
import TimePicker from '../TimePicker';

const TimeField = ({ title, name, validate, ...restProps }) => (
  <Field
    name={name}
    validate={validate}
    render={({ input, meta }) => (
      <TimePicker title={title} {...input} error={meta.touched && meta.error} {...restProps} />
    )}
  />
);

export default TimeField;
